const Geo = () => import('views/geo/Geo')
const AMap = () => import('views/geo/AMap')
const OpenLayersMap = () => import('views/geo/OpenLayersMap')
const ChartMap = () => import('views/geo/ChartMap')

export default {
  path: '/map',
  name: 'Geo',
  component: Geo,
  meta: { needAuth: false },
  children: [
    {
      path: '',
      name: 'AMap',
      component: AMap,
      meta: { needAuth: true }
    },
    {
      path: '/map/ol',
      name: 'OpenLayersMap',
      component: OpenLayersMap,
      meta: { title: 'OpenLayersMap', needAuth: false }
    },
    {
      path: '/map/chart',
      name: 'ChartMap',
      component: ChartMap,
      meta: { title: 'ChartMap', needAuth: false }
    }
  ]
}
